// The Payment Received form's standard prefill: oldest invoice first, each
// takes what it is owed until the amount runs out. Pure, so it is testable
// without the modal's dependencies.
export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export function allocateOldestFirst(amount, invoices) {
    let left = round2(amount);
    const out = {};
    for (const inv of invoices) {
        const take = round2(Math.min(round2(inv.balance), Math.max(0, left)));
        out[inv.zoho_invoice_id] = take > 0 ? take : 0;
        left = round2(left - take);
    }
    return out;
}
